import React, { useState } from 'react';
import SessionSettingsPopup from './SessionSettingsPopup';
import InviteParticipantsPopup from './InviteParticipantsPopup';

const StartSessionPopup = ({ popupIsOpen, onClose, userToken, loopId, loopName, organization, flash }) => {
  const [page, setPage] = useState('settings');
  const [payload, setPayload] = useState({});

  const onChangePage = (newPage, data) => {
    setPage(newPage);
    setPayload(data);
  };

  const handleClose = (redirectUrl) => {
    setPage('settings');
    onClose(redirectUrl);
  };

  const mapParticipants = (type) => {
    return (payload[type] || [])
      .filter((participant) => JSON.parse(participant).type === 'user')
      .map((participant) => parseInt(JSON.parse(participant).value));
  };

  const { OrganisationParticipations, teachers_can_invite } = window.viewer.options.organization;
  const canInvite = teachers_can_invite || OrganisationParticipations[0].is_owner;

  return (
    <>
      <SessionSettingsPopup
        userToken={userToken}
        loopId={loopId}
        loopName={loopName}
        onChangePage={onChangePage}
        isNew={true}
        organization={organization}
        popupIsOpen={popupIsOpen && page === 'settings'}
        onClose={handleClose}
        flash={flash}
        payload={payload}
      />
      <InviteParticipantsPopup
        userToken={userToken}
        loopId={loopId}
        onChangePage={onChangePage}
        isNew={true}
        isTeachers={false}
        popupIsOpen={popupIsOpen && page === 'participants'}
        onClose={handleClose}
        flash={flash}
        payload={payload}
        invitedParticipantIds={mapParticipants('teachers')}
        showInvitationEmail={canInvite}
      />
      <InviteParticipantsPopup
        userToken={userToken}
        loopId={loopId}
        onChangePage={onChangePage}
        isNew={true}
        isTeachers={true}
        popupIsOpen={popupIsOpen && page === 'teachers'}
        onClose={handleClose}
        flash={flash}
        payload={payload}
        invitedParticipantIds={mapParticipants('participants')}
        showInvitationEmail={false}
      />
    </>
  );
};

export default StartSessionPopup;
